import {ChangeDetectorRef, Component, HostBinding, Input} from "@angular/core";

@Component({
    selector: "fui-spinner",
    styleUrls: ["./spinner.component.scss"],
    templateUrl: "./spinner.component.html"
})
export class FUISpinnerComponent {
    private _active: boolean;
    private _modal: boolean;

    constructor(private changeDetectorRef: ChangeDetectorRef) {
    }

    get active(): boolean {
        return this._active;
    }

    get modal(): boolean {
        return this._modal;
    }

    /**
     *
     * @param {boolean} active
     */
    @HostBinding("class.active")
    @Input()
    set active(active: boolean) {
        this._active = active;
        this.changeDetectorRef.detectChanges();
    }

    /**
     *
     * @param {boolean} active
     */
    @HostBinding("class.modal")
    @Input()
    set modal(modal: boolean) {
        this._modal = modal;
        this.changeDetectorRef.detectChanges();
    }
}
